<app-sidebar />
<div class="core-container">
  <router-outlet />
</div>
